import { render, staticRenderFns } from "./CarrinhoOpcoesFrete.vue?vue&type=template&id=525c6636"
import script from "./CarrinhoOpcoesFrete.vue?vue&type=script&lang=js"
export * from "./CarrinhoOpcoesFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports